const StepHeader = ({ step }: { step: number }) => {
  return (
    <div className="text-sm sm:text-base font-semibold leading-6 text-gray-900 whitespace-nowrap">
      <span className={step === 1 ? "font-semibold" : ""}>Service List</span>
      {step >= 2 && (
        <>
          <span>/</span>
          <span className={step === 2 ? "font-semibold" : ""}>General Details</span>
        </>
      )}
      {step >= 3 && (
        <>
          <span>/</span>
          <span className={step === 3 ? "font-semibold" : ""}>Map Clinics & Setup Price</span>
        </>
      )}
    </div>
  );
};

export default StepHeader;
